export default "__VITE_ASSET__b10e3f9e__"